import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";

function AnimateLoading() {
  const [width, setWidth] = useState(0);
  const location = useLocation();
  const prevPathnameRef = useRef(location.pathname);
  const animateTimeoutRef = useRef();
  const stopAnimateTimeoutRef = useRef();

  useEffect(() => {
    if (prevPathnameRef.current !== location.pathname) {
      prevPathnameRef.current = location.pathname;
      const scrollToTopBtn = document.getElementById("kt_scrolltop");
      if (scrollToTopBtn) scrollToTopBtn.click();

      const animate = () => {
        setWidth((w) => {
          if (w < 100) {
            animateTimeoutRef.current = setTimeout(animate, 30);
            return w + 10;
          }
          stopAnimateTimeoutRef.current = setTimeout(() => setWidth(0), 300);
          return w;
        });
      };
      setWidth(0);
      animateTimeoutRef.current = setTimeout(animate, 30);
    }
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      if (stopAnimateTimeoutRef.current) clearTimeout(stopAnimateTimeoutRef.current);
      if (animateTimeoutRef.current) clearTimeout(animateTimeoutRef.current);
    };
  }, []);

  return (
    <div className="header-progress-bar" style={{ height: "3px", width: "100%" }}>
      {width > 0 && (
        <ProgressBar variant="info" now={width} style={{ height: "3px" }} />
      )}
    </div>
  );
}

export default AnimateLoading;
